import GooglePlaces from "../../lmm-widget/src/layers/types/GooglePlaces";
import { RichMarker } from 'libs/richmarker';
import { CATEGORIES_COLORS } from '../globals/categoriesColors';

export default GooglePlaces.extend({
    initialize(options) {
        GooglePlaces.prototype.initialize.call(this, options);

    },

    refreshCategory(category) {
        this.options.provider.load({ type: category });
        this.currentCategory = category;
    },

    add() {},

    _createMarker(feature) {
        const icon = this._getIconByCategory();
        let contentIcon = ``;
        if (icon.iconClass) {
            contentIcon = `<i class="melia-categories-panel-icon ${icon.iconClass}"></i>`;
        } else {
            contentIcon =
                `<img class="melia-categories-panel-image" src="${icon.imagePath}" alt="${icon.imagePath}" />`;
        }
        let contentStr =
            `
        <div class="category-marker"
            style="--category-color: ${CATEGORIES_COLORS[this.currentCategory]};">
                ${contentIcon}
        </div>
        `;
        let marker = new RichMarker({
            shadow: 'none',
            content: contentStr,
            position: new google.maps.LatLng(
                feature.geometry.coordinates[1], feature.geometry.coordinates[0]
            ),
            properties: feature.properties,
            zIndex: 10
        });
        return marker;
    },

    _getIconByCategory() {
        let icon = this.options.iconMarkerByType[this.currentCategory];
        if (!icon) {
            icon = this.options.iconMarkerByType['default']
        }
        return icon;
    }
});



// WEBPACK FOOTER //
// ./src/layers/CategoriesLayer.js